import React, { useCallback, useEffect, useState } from 'react';

import { useStore } from '../../../../hooks';

import './lobby.scss';

interface LobbyProps {

}

export const LobbyFrame: React.FC<LobbyProps> = () => {

  const { lobbyStore, gameStore, postMessageStore, userActivityStore } = useStore();
  const { launchData: { data: launchData } } = gameStore;

  const [lobbyFrameSource, setLobbyFrameSource] = useState('');

  useEffect(() => {
    if (launchData) {
      // generating lobby launch url
      const src = lobbyStore.generateLaunchUrl(launchData);
      setLobbyFrameSource(src);
    }
  }, [launchData]);

  const refCallback = useCallback((element: HTMLIFrameElement) => {
    postMessageStore.setLobbyIframeElement(element);
    userActivityStore.attachEventListeners(element?.contentWindow);
  }, []);

  return (
    lobbyFrameSource ? (
      <iframe
        ref={refCallback}
        src={lobbyFrameSource}
        className="lobby-frame"
        title="Pascal Gaming Lobby Frame"
        allow="fullscreen; clipboard-read; clipboard-write"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-forms allow-scripts allow-top-navigation"
      />
    ) : null
  );
};
